import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-assessment.service";

export const useAdminAssessment = createUseData(
    service.getAssessment,
)